export const DEFAULT_HOST = 'WEB';
export const DEFAULT_PATH = '/welcome';
